export default __webpack_public_path__ + "static/media/bonus-code-ico.0ccb4015.svg";